import { CARD_ERROR_MESSAGES } from '#client/components/MoveMoney/InstantDepositModal/constants/instants';
import {
  ASTRA_CARD_STATUS,
  ASTRA_CARD_TYPE,
  ASTRA_CARD_REVIEW_STATUS
} from '#client/constants/astra';

// replace character by index
export const replaceCharAt = (string, index, replace) =>
  string.substring(0, index) + replace + string.substring(index + 1);

export const getCardByType = (cardType = '', cardList = []) =>
  cardList.find((card) => card.type === cardType);

export const checkCardErrors = (card = {}) => {
  const { cardType, cardStatus, cardReviewStatus, cardExpirationDate, isCardPullEnabled } = card;

  if (cardType !== ASTRA_CARD_TYPE.DEBIT) {
    return CARD_ERROR_MESSAGES.NOT_DEBIT_CARD;
  }

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear() % 100;
  const currentMonth = currentDate.getMonth() + 1;
  const [expirationMonth, expirationYear] = cardExpirationDate.split('/').map(Number);

  if (
    expirationYear < currentYear ||
    (expirationYear === currentYear && expirationMonth < currentMonth)
  ) {
    return CARD_ERROR_MESSAGES.EXPIRED;
  }

  if (cardStatus === ASTRA_CARD_STATUS.PENDING) {
    return CARD_ERROR_MESSAGES.PENDING_APPROVAL;
  }

  if (
    cardStatus !== ASTRA_CARD_STATUS.APPROVED ||
    cardReviewStatus !== ASTRA_CARD_REVIEW_STATUS.APPROVED
  ) {
    return CARD_ERROR_MESSAGES.COULD_NOT_PROCESS_WITH_THIS_CARD;
  }

  if (!isCardPullEnabled) {
    return CARD_ERROR_MESSAGES.COULD_NOT_PROCESS_WITH_THIS_CARD;
  }

  return null;
};
